/**
 * Keeps track of what folder is currently selected.
 *
 * @NOTE (som, 2019-12-30): in practice, this is instantiated in and is essentially part of
 * `DashboardViewStore` in the app. By tracking the folder selection state in this separate store
 * however, we allow components to access this state in a generic way, without needing to be tied to
 * a much bigger store like `DashboardViewStore`.
 */

import { ISelectionStateProvider, FolderTreeId } from "../FolderTreeViewStore";
import { observable, computed, action } from "mobx";

type FolderSelectionState = FolderTreeId | undefined;

class FolderSelectionViewStore implements ISelectionStateProvider {
  @observable.ref
  private _selectedFolder: FolderSelectionState;

  constructor(initialState?: FolderSelectionState) {
    this._selectedFolder = initialState;
  }

  @computed
  public get selectedFolder(): FolderSelectionState {
    return this._selectedFolder;
  }

  @action.bound
  public setSelectedFolder(folderId: FolderSelectionState): void {
    this._selectedFolder = folderId;
  }
}

export { FolderSelectionViewStore, FolderSelectionState };
